import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requiredPermission }) {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50" data-testid="auth-loading">
        <Loader2 className="w-6 h-6 text-slate-500 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (user.must_change_password && location.pathname !== "/force-password-change") {
    return <Navigate to="/force-password-change" replace />;
  }

  if (!user.must_change_password && location.pathname === "/force-password-change") {
    return <Navigate to="/" replace />;
  }

  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <div className="p-10 text-center" data-testid="forbidden-screen">
        <h2 className="text-xl font-semibold text-slate-800">Access denied</h2>
        <p className="text-slate-500 mt-2">Your role does not include the “{requiredPermission}” permission.</p>
        <Link to="/" data-testid="forbidden-go-dashboard-btn" className="inline-flex mt-5 px-4 py-2 rounded-md bg-[#0b192c] hover:bg-[#0f2544] text-white text-sm font-medium transition-colors">
          Go to Dashboard
        </Link>
      </div>
    );
  }

  return children;
}
